module.exports = __webpack_public_path__ + "img/nloadingg.456d4d07.gif";